import * as React from 'react';
import { useEffect, useRef } from 'react';

interface TypekitLoaderProps {
    id: string;
}

export const TypekitLoader: React.FC<TypekitLoaderProps> = ({ id }) => {
    const container = useRef(document.getElementsByTagName('body')[0]);
    const script = useRef<HTMLScriptElement>();

    useEffect(() => {
        const createScript = (onLoad: () => any) => {
            const s = document.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.onload = () => {
                onLoad();
            };

            s.src = `//use.typekit.net/${id}.js`;
            container.current.append(s);

            script.current = s;
        };

        createScript(() => {
            try {
                window.Typekit.load();
            } catch (e) {
                //
            }
        });

        return () => {
            container.current.removeChild(script.current);
            script.current = null;
        };
    }, [id]);

    return null;
};

TypekitLoader.displayName = 'TypekitLoader';
